<template>
    <div class="surveys">
        <List v-if="!responses && client_id" :DB="list" :client_id="client_id" @emit="emit"/>
        <Responses v-if="responses" :survey_id="this.survey_id" @emit="emit" /> 
        <component v-if="component" :is="component" :item="item" @emit="emit" />
    </div>
</template>

<script>

import { mapMutations } from 'vuex'
import List from '../components/List.vue'
import { format } from 'date-fns';
import prettyPhone from '../utils/prettyPhone.js'
import WebSoc from '../utils/WebSoc.js';
import Responses from '../components/Responses.vue'
import Alert from '../utils/Alert.js';

export default {
    name: 'surveys',
    components: {
        List,
        Responses
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    created () {
        this.list.filter.client_id = this.client_id;       
    },
    data () {
        return {
            component: '',
            item: false,
            responses: false,
            survey_id: '',
            db: '',
            list: { 
                t: 'surveys-list',
                DB: 'surveys',
                dbClient_id: '',
                storeDB: true,
                title: 'Surveys',
                fields: [
                    { title: 'Title', class: 'td-ulb', field: 'title', width: 400 },
                    { title: 'Clicks', class: 'ta-r', field: 'clicks' },
                    { title: 'Last Visit', class: 'ta-r', field: 'lastClick', map: item => item.lastClick > 0 && format(item.lastClick,'dd/MM/yy HH:mm'), width: 160, }
                ],
                filter: { loyalty: { $ne: true }, live: true },
                onItems ( items ) {

                }
            } 
        }
    },
    methods: {
        getResponses ( data ) {
            this.db = data.item._id+'-responses';
            this.survey_id = data.item._id;
            this.responses = true;
        },
        'responses-list' ( data ) {
            console.log('responses-list data',data);
            switch ( data.field.field ) {
                case 'created': Alert.yesno('Delete item?',yes => {
                    if ( !yes ) return;
                    WebSoc.SEND('delete',{ DB: this.db, _id: data.item._id },resp => {
                        console.log('delete resp',resp);
                    });
                })
            }
        },
        'surveys-list' ( data ) {
            
            switch ( data.field.field ) {
                case 'title':
                    return this.getResponses(data)
            }
            
            console.log('email suyveys-list',data);

        },
        emit ( data ) {
            console.log('emit',data);
            if ( data.action == 'exit' ) {
                this.responses = false;
                this.component = '';
                this.item = false
            }

            if ( typeof this[data.t] == 'function' ) return this[data.t](data);
            console.log('what emmit',data);
        },
        
    }
}    

</script>

<style>

</style>